import { AppTitle } from "../AppTitle/AppTitle";
import MenuTrigger from "../Menu/MenuTrigger";
import EthButton from "../Modal/Buttons/AuthButtons/EthButtons/EthButton";
import TonDisconnectButton from "../Modal/Buttons/AuthButtons/TonButtons/TonDisconnectButton";
import SignOutButton from "../Modal/Buttons/AuthButtons/Web2Buttons/SignOutButton";
import { HeaderContainer } from "./HeaderContainer";
import { useTonConnectUI } from "@tonconnect/ui-react";
import React, { useCallback, useEffect, useState } from "react";
import { useAccount } from "wagmi";

export default function Header({ username, updateProfile }: any) {
  const [tonConnectUI] = useTonConnectUI();
  const { isConnected } = useAccount();
  const [isTonConnected, setIsTonConnected] = useState(tonConnectUI.connected);

  useEffect(() => {
    const unsubscribe = tonConnectUI.onStatusChange(() => {
      setIsTonConnected(tonConnectUI.connected);
    });
    return () => unsubscribe();
  }, [tonConnectUI]);

  const renderWalletInfo = useCallback(() => {
    if (isTonConnected) {
      return <TonDisconnectButton updateProfile={updateProfile} />;
    } else if (username) {
      return (
        <SignOutButton username={username} updateProfile={updateProfile} />
      );
    } else if (isConnected) {
      return <EthButton mainModalClose={() => console.log("close")} />;
    }
    return <MenuTrigger updateProfile={updateProfile} />;
  }, [isTonConnected, isConnected, username, updateProfile]);

  return (
    <HeaderContainer>
      <AppTitle />
      <div className="auth-buttons">{renderWalletInfo()}</div>
    </HeaderContainer>
  );
}
